import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// PrimeVue
import PrimeVue from 'primevue/config';
import Material from '@primeuix/themes/material';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import 'primeicons/primeicons.css'

// Vuelidate ile ilgili importları kaldırıyoruz

// Axios
import axiosInstance from '@/lib/axios'

const app = createApp(App)

// Store ve Router ekleme
app.use(store)
app.use(router)

// Axios'u global olarak erişilebilir yap
app.config.globalProperties.$http = axiosInstance

// Vuelidate ile ilgili kodu kaldırıyoruz

// PrimeVue tema ve servisleri
app.use(PrimeVue, {
    theme: {
        preset: Material,
        options: {
            prefix: 'p',
            darkModeSelector: '.my-app-dark',
            cssLayer: false
        }
    },
    ripple: true
});

// Auth durumunu dinleme ve store'a aktarma
store.dispatch('subscribeToAuthChanges');
// Başlangıçta oturum durumunu kontrol et
store.dispatch('fetchSession');

app.use(ConfirmationService);
app.use(ToastService);
app.directive('tooltip', Tooltip);

app.mount('#app')
